export default __webpack_public_path__ + "static/media/react.926b875b.png";